import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
    useLazyGetNavdataAirportQuery,
    useLazySearchNavdataAirportQuery,
} from 'ff/debrief/features/TracklogApi';
import { convertApproachLegs } from 'ff/debrief/common/approach_util';
import type { InputData } from 'ff/debrief/common/approach_util';
import useDebug from 'ff/common/debugMode/useDebug';
import type { NavDataAirportSearchResult } from 'ff/debrief/models';

const DebugControlsPanel = styled.div`
    position: fixed;
    top: 10px;
    right: 220px;
    width: 500px;
    height: 40px;
    display: flex;
    flex-direction: row;
    z-index: 9999;
`;

const SearchResults = styled.div`
    background-color: #fff;
    position: fixed;
    top: 40px;
    //width: 300px;
    height: 500px;
    z-index: 99999;
    overflow-y: auto;
`;

const ResultRow = styled.div`
    padding: 10px;
    border-bottom: 1px solid #999;
`;

const SelectedItem = styled.div`
    color: #fff;
    padding: 0 10px;
`;

interface ProcedureData {
    name?: string;
    procedure_id?: string;
    type?: string;
    legs?: unknown[];
}

export const DebugControls = () => {
    const [getNavDataAirport, { data }] = useLazyGetNavdataAirportQuery();
    const [searchAirports, { data: airportSearch }] =
        useLazySearchNavdataAirportQuery();
    const [selectedAirport, setSelectedAirport] = useState<
        NavDataAirportSearchResult | undefined
    >(undefined);
    const [selectedProcedure, setSelectedProcedure] = useState<
        ProcedureData | undefined
    >(undefined);
    const { setApproachHandler } = useDebug();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        if (query.length >= 3) {
            searchAirports(query);
        }
    };

    const handleSelectAirport = () => {
        console.log('selected airport', selectedAirport?.identifier);
        getNavDataAirport(selectedAirport?.airport_id);
    };

    const resetForm = (
        e?:
            | React.FormEvent<HTMLFormElement>
            | React.MouseEvent<HTMLButtonElement>
    ) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setSelectedAirport(undefined);
        setSelectedProcedure(undefined);
        const element = document.getElementById(
            'debug-airport-search'
        ) as HTMLInputElement;
        if (element) {
            element.value = '';
        }
    };

    useEffect(() => {
        handleSelectAirport();
    }, [selectedAirport]);

    useEffect(() => {
        if (!selectedProcedure) {
            setApproachHandler(undefined);
        } else {
            //TODO: when api formats for us, can remove this and the utils file
            const formatted = convertApproachLegs(
                selectedProcedure as InputData
            );
            setApproachHandler(formatted);
        }
    }, [selectedProcedure]);

    return (
        <DebugControlsPanel>
            {
                <SelectedItem>
                    {selectedAirport && selectedAirport?.identifier}
                </SelectedItem>
            }
            {
                <SelectedItem>
                    {selectedProcedure && selectedProcedure?.name}
                </SelectedItem>
            }
            <form onReset={resetForm}>
                <input
                    id="debug-airport-search"
                    type="text"
                    placeholder="Search Airport Code"
                    onChange={handleSearch}
                />
                <button type="reset" onClick={resetForm}>
                    Reset
                </button>
            </form>
            {!selectedProcedure && (
                <SearchResults>
                    {!selectedAirport?.airport_id &&
                        airportSearch?.length > 0 &&
                        airportSearch?.map(airport => {
                            return (
                                <ResultRow
                                    key={airport.airport_id}
                                    onClick={() => setSelectedAirport(airport)}
                                >
                                    <p>
                                        <strong>{airport.name}</strong> (
                                        {airport.identifier})
                                    </p>
                                    <p>
                                        Location: {airport.city_name},{' '}
                                        {airport.state_code}{' '}
                                        {airport.country_code}
                                    </p>
                                </ResultRow>
                            );
                        })}
                    {selectedAirport &&
                        data?.map(procedure => {
                            return (
                                <ResultRow
                                    key={procedure?.procedure_id}
                                    onClick={() =>
                                        setSelectedProcedure(procedure)
                                    }
                                >
                                    <p>
                                        <strong>{procedure?.name}</strong>
                                    </p>
                                </ResultRow>
                            );
                        })}
                </SearchResults>
            )}
        </DebugControlsPanel>
    );
};
